<template>
  <div class="" v-if="waterData">
    <div class="flex" style="margin-top: 2%">
      <div class="" style="width: 49%">
        <div class="title">灌溉水量</div>
        <one ref="one" :waterData="waterData"></one>
      </div>
      <div class="" style="width: 49%">
        <div class="title">灌溉效率</div>
        <two ref="two" :waterData="waterData"></two>
      </div>
    </div>
    <div class="" style="width: 99%; margin-top: 2%">
      <div class="title" style="margin-bottom: 2%">水分动态</div>
      <three ref="three" :waterData="waterData"></three>
    </div>
  </div>
</template>

<script>
import one from "./waterOnDemand/one.vue";
import two from "./waterOnDemand/two.vue";
import three from "./waterOnDemand/three.vue";
export default {
  components: { one, two, three },
  props: {
    waterId: {
      type: String,
    },
  },
  data() {
    return {
      waterData: null,
    };
  },
  created() {
    this.$request(`iot/screen/water/getRate?id=${this.waterId}`).then((res) => {
      this.waterData = res.data;
    });
  },
  watch: {
    waterId() {
      this.$request(`iot/screen/water/getRate?id=${this.waterId}`).then(
        (res) => {
          this.waterData = res.data;
          this.$refs.one.init();
          this.$refs.two.init();
          this.$refs.three.init();
        }
      );
    },
  },
};
</script>

<style>
</style>